import React from 'react'
import { Button } from 'react-bootstrap'

const SuccessView = ({ history, onHide }) => (
  <div className="p-4">
    <div className="flex flex-column align-items-center mb-4">
      <div className="color-purple mb-2 font-22">Account upgraded</div>
      <div className="flex align-items-center">
        <img className="me-3" height="40px" width="40px" alt="check" src="/check.png" />
        <span>Your account has been successfully upgraded.</span>
      </div>
    </div>
    <div className="d-flex justify-content-end">
      <Button
        onClick={() => {
          history.push('/'), onHide()
        }}
      >
        Done
      </Button>
    </div>
  </div>
)

export default SuccessView
